import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface Brand {
  id: string
  name: string
  slug: string
  description?: string
  logo_url?: string
  primary_color?: string
  secondary_color?: string
  vertical?: string
  created_at: string
}

interface BrandsState {
  brands: Brand[]
  selectedBrand: Brand | null
  isLoading: boolean
}

const initialState: BrandsState = {
  brands: [],
  selectedBrand: null,
  isLoading: false,
}

const brandsSlice = createSlice({
  name: 'brands',
  initialState,
  reducers: {
    setBrands: (state, action: PayloadAction<Brand[]>) => {
      state.brands = action.payload
    },
    setSelectedBrand: (state, action: PayloadAction<Brand | null>) => {
      state.selectedBrand = action.payload
    },
    addBrand: (state, action: PayloadAction<Brand>) => {
      state.brands.push(action.payload)
    },
    updateBrand: (state, action: PayloadAction<Brand>) => {
      const index = state.brands.findIndex(b => b.id === action.payload.id)
      if (index !== -1) {
        state.brands[index] = action.payload
      }
    },
    removeBrand: (state, action: PayloadAction<string>) => {
      state.brands = state.brands.filter(b => b.id !== action.payload)
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
  },
})

export const { setBrands, setSelectedBrand, addBrand, updateBrand, removeBrand, setLoading } = brandsSlice.actions
export default brandsSlice.reducer

